import React, { useState } from "react";
import "./Registration.css"; // Import CSS

const Registration = () => {
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    mobile: "",
    diagnosis: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    alert("Form Submitted!");
  };

  return (
    <div className="registration-container">
      <div className="registration-box">
        <h1 className="form-title">Registration Form</h1>
        <p className="form-subtitle">
          Please fill out the form carefully for registration.
        </p>

        <form onSubmit={handleSubmit} className="form-grid">
          {/* Name */}
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter full name"
              required
            />
          </div>

          {/* Age */}
          <div className="form-group">
            <label htmlFor="age">Age</label>
            <input
              type="number"
              id="age"
              name="age"
              value={formData.age}
              onChange={handleChange}
              placeholder="Enter age"
              required
            />
          </div>

          {/* Mobile */}
          <div className="form-group">
            <label htmlFor="mobile">Mobile Number</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter 10-digit mobile number"
              pattern="[0-9]{10}"
              title="Enter a valid 10-digit phone number"
              required
            />
          </div>

          {/* Diagnosis */}
          <div className="form-group form-group-full">
            <label htmlFor="diagnosis">Diagnosis</label>
            <textarea
              id="diagnosis"
              name="diagnosis"
              value={formData.diagnosis}
              onChange={handleChange}
              placeholder="Enter diagnosis details"
              rows="3"
              required
            ></textarea>
          </div>

          {/* Submit */}
          <div className="form-submit">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Registration;
